'use client'

import type React from 'react'
import {
	AnalyticsProvider as AnalyticsContextProvider,
	useInitializeAnalytics,
} from '@/lib/analytics/analytics'

type AnalyticsProviderProps = {
	readonly children: React.ReactNode
	readonly amplitudeApiKey?: string
}

export function AnalyticsProvider({ children, amplitudeApiKey }: AnalyticsProviderProps) {
	const analytics = useInitializeAnalytics({ amplitudeApiKey })

	return <AnalyticsContextProvider value={analytics}>{children}</AnalyticsContextProvider>
}
